export enum EOs {
  Other = 'other',
  Ios = 'ios',
  Android = 'android',
}
